var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contact-filter-field',{attrs:{"schema":_vm.filterSchema,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }